import useColumns from "./useColumns"
import useTabs from './useTabs'
import useCreateTicketMessageBtn from './useCreateTicketMessageBtn'
import useCloseTicket from "./useCloseTicket"
import useTicketDetails from './useTicketDetails'
import useHeaderBtns from './useHeaderBtns'
import useToBeDeveloped from './useToBeDeveloped'

export default { useToBeDeveloped, useColumns, useHeaderBtns, useCloseTicket, useTicketDetails, useTabs, useCreateTicketMessageBtn }